import { createContext, useContext } from "react";
import { useRolePermissions } from "../hooks/useRolePermissions";

const RoleCtx = createContext(undefined);

export function RoleProvider({ children }) {
  const value = useRolePermissions();
  return <RoleCtx.Provider value={value}>{children}</RoleCtx.Provider>;
}

export function useRole() {
  const ctx = useContext(RoleCtx);
  if (ctx === undefined) {
    throw new Error("useRole must be used within <RoleProvider>");
  }
  return ctx;
}
